<div class="mini-navigation" [ngClass]="miniNavigation.classNames">
  <ul class="mini-navigation__list">
    @for (field of miniNavigation.hierarchy.fields.destinations; track $index) {
      <li class="mini-navigation__list-item">
        @if (field.fields.url.startsWith('#')) {
          <a [fragment]="field.fields.url.replace('#', '')" [routerLink]="[]" target="_self">
            <app-contentful-cloudinary-image [cloudinaryImage]="field.fields.image.fields" [mediaType]="'image'" />
            <div [innerHTML]="field.fields.title | sanitizeContent: 'html'"></div>
          </a>
        } @else {
          <a [href]="field.fields.url" target="_blank">
            <app-contentful-cloudinary-image [cloudinaryImage]="field.fields.image.fields" [mediaType]="'image'" />
            <div [innerHTML]="field.fields.title | sanitizeContent: 'html'"></div>
          </a>
        }
      </li>
    }
  </ul>
</div>
